<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa header-toggle-icon"
      [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
      (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times header-close-icon"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  @if (!showFormLoader) {
<div>
    <table class="table table-bordered table-condensed table-hover boldText detail-toggle-table" [hidden]="disableTable">
      <thead>
        <tr>
          <th colspan="5">
            <i class="fa"
              [ngClass]="{'fa-plus-square-o': tableMinimise, 'fa-minus-square-o': !tableMinimise}"
              style="margin-right: 10px; cursor: pointer;"
              (click)="toggleDetailTable()"></i>
            {{ tableTitle }}
          </th>
        </tr>
      </thead>
      <tbody [hidden]="tableMinimise">
        <tr>
          <td></td>
          <td><b>Account No.</b></td>
          <td><b>Account Description</b></td>
          <td><b>Counterparty</b></td>
          <td><b>Dividend Amt</b></td>
        </tr>
        @for (record of detailRows; track $index) {
<tr>
          <td></td>
          <td>{{ record.ACCT }}</td>
          <td>{{ record.ACCT_DESC }}</td>
          <td>{{ record.COUNTER_PARTY }}</td>
          <td>{{ record[detailAmountKey] | number:'1.0-2' }}</td>
        </tr>
}
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td><b>Total</b></td>
          <td>{{ detailTotal | number:'1.0-2' }}</td>
        </tr>
      </tbody>
    </table>

    <div class="form-horizontal">
      <div class="form-group top-row">
        <label class="col-sm-3 control-label">Dividend Type:</label>
        <div class="col-sm-4">
          <select class="form-control" [ngModel]="selectedDividendType" (ngModelChange)="onDividendTypeChange($event)">
            <option [ngValue]="null">--- Select type of dividend ---</option>
            @for (t of dividendTypes; track $index) {
<option [ngValue]="t">{{ t.CODE_DESC }}</option>
}
          </select>
          @if (divTypeInvalid) {
<span class="form-error-container">Please select dividend type </span>
}
        </div>
        <div class="col-sm-3 text-right">
          <a href="javascript:void(0)" (click)="deleteDividend()">Delete Dividend</a>
        </div>
      </div>

      <div class="form-group">
        <label class="col-sm-3 control-label">Dividend Date:</label>
        <div class="col-sm-4">
          <div class="input-group">
            <input class="form-control" type="date"
              [ngModel]="paymentDate"
              (ngModelChange)="onPaymentDateChange($event)"
              (keydown)="blockManualDateEntry($event)"
              (paste)="$event.preventDefault()"
              (drop)="$event.preventDefault()">
            <span class="input-group-addon"><i class="glyphicon glyphicon-calendar"></i></span>
          </div>
          @if (dateInvalid) {
<span class="form-error-container">You can only enter date between {{ dateRangeBeginDisplay }} to {{ dateRangeEndDisplay }} </span>
}
        </div>
      </div>

      <div class="row split-pane">
        <div class="col-md-6">
          <fieldset class="fieldset-border">
            <legend class="legend-border">Dividend Paid</legend>
            <div class="form-horizontal">
              <div class="form-group">
                <label class="col-md-4 control-label">Payor:</label>
                <div class="col-md-7">
                  <div class="autocomplete-wrapper">
                    <div class="input-group">
                      <input class="form-control input-sm"
                        [class.locked-input]="payorDisabled"
                        [value]="payorEntityDisplay || ''"
                        [readonly]="payorDisabled"
                        [attr.disabled]="payorDisabled ? '' : null"
                        (input)="onPayorSearchChange($any($event.target).value)"
                        placeholder="begin typing to Search for an entity by GOLD ID">
                      <span class="input-group-addon">
                        @if (loadingPayorSearch && activeSearchField === 'payor') {
<i class="fa fa-spinner fa-pulse"></i>
}
                        @if (!loadingPayorSearch || activeSearchField !== 'payor') {
<i class="fa fa-search"></i>
}
                      </span>
                    </div>
                    @if (payorEntities.length > 0 && activeSearchField === 'payor') {
<div class="autocomplete-dropdown">
                      @for (entity of payorEntities; track $index) {
<div class="autocomplete-item"
                       
                        (click)="selectPayorEntity(entity)">
                        {{ entity.DISPLAY_VALUE || entity.LE_NAME || entity.LEID }}
                      </div>
}
                    </div>
}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label">Payor Trial Balance/Currency:</label>
                <div class="col-md-7">
                  @if (payorTbDisabled) {
                    <input class="form-control input-sm locked-input"
                           [value]="selectedPayorFeed?.FEED_DISPLAY || ''"
                           readonly
                           disabled>
                  } @else {
                    <select class="form-control input-sm"
                            [ngModel]="selectedPayorFeed"
                            (ngModelChange)="onPayorFeedChange($event)">
                      <option [ngValue]="null">--- Select TB/Currency ---</option>
                      @for (feed of payorFeeds; track $index) {
<option [ngValue]="feed">{{ feed.FEED_DISPLAY }}</option>
}
                    </select>
                  }
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label">Payor Amount:</label>
                <div class="col-md-4">
                  <div class="input-group">
                    <input class="form-control text-right"
                           [ngModel]="payorAmount"
                           [disabled]="payorAmtDisabled"
                           (ngModelChange)="payorAmount = $event"
                           (blur)="validateAmt(payorAmount, selectedPayorFeed?.WTD_AVG_RATE || 1, 'PAIDOBJ', 'PAYOR_AMT_USD', 'payor_amt')">
                    <span class="input-group-addon">{{ selectedPayorFeed?.CURR || '' }}</span>
                  </div>
                  @if (payorAmtInvalid) {
<span class="form-error-container">Amount should not be negative.</span>
}
                </div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input class="form-control text-right" [ngModel]="payorAmountUsd" disabled>
                    <span class="input-group-addon">USD</span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label">Withholding Tax:</label>
                <div class="col-md-4">
                  <div class="input-group">
                    <input class="form-control text-right"
                           [ngModel]="payorTaxAmount"
                           [disabled]="payorTaxAmtDisabled"
                           (ngModelChange)="payorTaxAmount = $event"
                           (blur)="validateAmt(payorTaxAmount, selectedPayorFeed?.WTD_AVG_RATE || 1, 'PAIDOBJ', 'PAYOR_TAX_AMT_USD', 'payor_tax_amt')">
                    <span class="input-group-addon">{{ selectedPayorFeed?.CURR || '' }}</span>
                  </div>
                  @if (payorTaxAmtInvalid) {
<span class="form-error-container">Amount should not be negative.</span>
}
                </div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input class="form-control text-right" [ngModel]="payorTaxAmountUsd" disabled>
                    <span class="input-group-addon">USD</span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label">Cash Distribution:</label>
                <div class="col-md-7 radio-row">
                  <span>Yes</span>
                  <input type="radio" name="cashDist" [value]="'Y'" [(ngModel)]="cashDist" [disabled]="payorAmtDisabled">
                  <span>No</span>
                  <input type="radio" name="cashDist" [value]="'N'" [(ngModel)]="cashDist" [disabled]="payorAmtDisabled">
                </div>
              </div>

              @if (cashDist === 'N') {
<div class="form-group">
                <label class="col-md-4 control-label unWrap">Tax Basis Value:</label>
                <div class="col-md-4">
                  <div class="input-group">
                    <input class="form-control text-right"
                           [ngModel]="taxBaseAmount"
                           (ngModelChange)="taxBaseAmount = $event"
                           (blur)="validateAmt(taxBaseAmount, selectedPayorFeed?.WTD_AVG_RATE || 1, 'CASHDISTOBJ', 'TAX_BASE_VAL_USD', 'tax_base_val')">
                    <span class="input-group-addon">{{ selectedPayorFeed?.CURR || '' }}</span>
                  </div>
                  @if (taxBaseAmtInvalid) {
<span class="form-error-container">Amount should not be negative.</span>
}
                </div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input class="form-control text-right" [ngModel]="taxBaseAmountUsd" disabled>
                    <span class="input-group-addon">USD</span>
                  </div>
                </div>
              </div>
}
            </div>
          </fieldset>
        </div>

        <div class="col-md-6">
          <fieldset class="fieldset-border">
            <legend class="legend-border">Dividend Received</legend>
            <div class="form-horizontal">
              <div class="form-group">
                <label class="col-md-4 control-label">Recipient:</label>
                <div class="col-md-7">
                  <div class="autocomplete-wrapper">
                    <div class="input-group">
                      <input class="form-control input-sm"
                        [class.locked-input]="payeeDisabled"
                        [value]="payeeEntityDisplay || ''"
                        [readonly]="payeeDisabled"
                        [attr.disabled]="payeeDisabled ? '' : null"
                        (input)="onPayeeSearchChange($any($event.target).value)"
                        placeholder="begin typing to Search for an entity by GOLD ID">
                      <span class="input-group-addon">
                        @if (loadingPayeeSearch && activeSearchField === 'payee') {
<i class="fa fa-spinner fa-pulse"></i>
}
                        @if (!loadingPayeeSearch || activeSearchField !== 'payee') {
<i class="fa fa-search"></i>
}
                      </span>
                    </div>
                    @if (payeeEntities.length > 0 && activeSearchField === 'payee') {
<div class="autocomplete-dropdown">
                      @for (entity of payeeEntities; track $index) {
<div class="autocomplete-item"
                       
                        (click)="selectPayeeEntity(entity)">
                        {{ entity.DISPLAY_VALUE || entity.LE_NAME || entity.LEID }}
                      </div>
}
                    </div>
}
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label">Recipient Trial Balance/Currency:</label>
                <div class="col-md-7">
                  @if (payeeTbDisabled) {
                    <input class="form-control input-sm locked-input"
                           [value]="selectedPayeeFeed?.FEED_DISPLAY || ''"
                           readonly
                           disabled>
                  } @else {
                    <select class="form-control input-sm"
                            [ngModel]="selectedPayeeFeed"
                            (ngModelChange)="onPayeeFeedChange($event)">
                      <option [ngValue]="null">--- Select TB/Currency ---</option>
                      @for (feed of payeeFeeds; track $index) {
<option [ngValue]="feed">{{ feed.FEED_DISPLAY }}</option>
}
                    </select>
                  }
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label">Recipient Amount:</label>
                <div class="col-md-4">
                  <div class="input-group">
                    <input class="form-control text-right"
                           [ngModel]="payeeAmount"
                           [disabled]="payeeAmtDisabled"
                           (ngModelChange)="payeeAmount = $event"
                           (blur)="validateAmt(payeeAmount, selectedPayeeFeed?.WTD_AVG_RATE || 1, 'RECEIVEDOBJ', 'PAYEE_AMT_USD', 'payee_amt')">
                    <span class="input-group-addon">{{ selectedPayeeFeed?.CURR || '' }}</span>
                  </div>
                  @if (payeeAmtInvalid) {
<span class="form-error-container">Amount should be negative.</span>
}
                </div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input class="form-control text-right" [ngModel]="payeeAmountUsd" disabled>
                    <span class="input-group-addon">USD</span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="col-md-4 control-label">Withholding Tax:</label>
                <div class="col-md-4">
                  <div class="input-group">
                    <input class="form-control text-right"
                           [ngModel]="payeeTaxAmount"
                           [disabled]="payeeTaxAmtDisabled"
                           (ngModelChange)="payeeTaxAmount = $event"
                           (blur)="validateAmt(payeeTaxAmount, selectedPayeeFeed?.WTD_AVG_RATE || 1, 'RECEIVEDOBJ', 'PAYEE_TAX_AMT_USD', 'payee_tax_amt')">
                    <span class="input-group-addon">{{ selectedPayeeFeed?.CURR || '' }}</span>
                  </div>
                  @if (payeeTaxAmtInvalid) {
<span class="form-error-container">Amount should not be negative.</span>
}
                </div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input class="form-control text-right" [ngModel]="payeeTaxAmountUsd" disabled>
                    <span class="input-group-addon">USD</span>
                  </div>
                </div>
              </div>

              @if (selectedDividendType?.CODE_ID === '2' || selectedDividendType?.CODE_ID === 2) {
<div class="form-group">
                <label class="col-md-4 control-label unWrap" for="trans_curr_304">Transactional Currency:</label>
                <div class="col-md-7">
                  <select id="trans_curr_304" class="form-control input-sm"
                    [ngModel]="selectedCurrency"
                    (ngModelChange)="onTransCurrencyChange($event)">
                    <option [ngValue]="null">--- Select Transactional Currency ---</option>
                    @for (c of transCurrencies; track $index) {
<option [ngValue]="c">{{ c.CURR_DISPLAY }}</option>
}
                  </select>
                </div>
              </div>
}

              @if (selectedDividendType?.CODE_ID === '2' || selectedDividendType?.CODE_ID === 2) {
<div class="form-group">
                <label class="col-md-4 control-label unWrap" for="trans_304_amt">Amount in Transaction Currency:</label>
                <div class="col-md-4">
                  <div class="input-group">
                    <input id="trans_304_amt" class="form-control text-right"
                      [disabled]="trans304AmountDisabled"
                      [ngModel]="trans304Amount"
                      (ngModelChange)="trans304Amount = $event"
                      (blur)="validateAmt(trans304Amount, selectedCurrency?.WTD_AVG_RATE || 1, 'TRANS304OBJ', 'TRANS_304_AMT_USD', 'trans_304_amt')">
                    <span class="input-group-addon">{{ selectedCurrency?.CURR_CODE || '' }}</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="input-group">
                    <input class="form-control text-right" [ngModel]="trans304AmountUsd" disabled>
                    <span class="input-group-addon">USD</span>
                  </div>
                </div>
              </div>
}
            </div>
          </fieldset>
        </div>
      </div>

      <div class="form-group intl-row">
        <label class="col-sm-3 control-label">International Transactions Entry Id:</label>
        <div class="col-sm-4">
          <div class="autocomplete-wrapper">
            <div class="input-group">
              <input class="form-control input-sm"
                [value]="intlTransSearch || ''"
                (input)="onIntlTransSearchChange($any($event.target).value)"
                placeholder="begin typing to Search for transaction ID">
              <span class="input-group-addon">
                @if (loadingIntlTransSearch && activeSearchField === 'intlTrans') {
<i class="fa fa-spinner fa-pulse"></i>
}
                @if (!loadingIntlTransSearch || activeSearchField !== 'intlTrans') {
<i class="fa fa-search"></i>
}
              </span>
            </div>
            @if (intlTransOptions.length > 0 && activeSearchField === 'intlTrans') {
<div class="autocomplete-dropdown">
              @for (trans of intlTransOptions; track $index) {
<div class="autocomplete-item"
               
                (click)="selectIntlTrans(trans)">
                {{ trans.DISPLAY_VALUE || trans.ENTRY_ID }}
              </div>
}
            </div>
}
          </div>
        </div>
      </div>

      @if (selectedDividendType?.CODE_ID === '2' || selectedDividendType?.CODE_ID === 2) {
<div class="form-group intl-row">
        <label class="col-sm-3 control-label unWrap" for="target304Entity">Target Entity:</label>
        <div class="col-sm-4">
          <div class="autocomplete-wrapper">
            <div class="input-group">
              <input class="form-control input-sm"
                type="text"
                id="target304Entity"
                name="target304Entity"
                [disabled]="targetEntity304Disabled"
                [attr.required]="!targetEntity304Disabled ? '' : null"
                [value]="entity304Display || ''"
                (input)="onEntity304SearchChange($any($event.target).value)"
                placeholder="begin typing to Search for 304 entity">
              <span class="input-group-addon">
                @if (loadingEntity304Search && activeSearchField === 'entity304') {
<i class="fa fa-spinner fa-pulse"></i>
}
                @if (!loadingEntity304Search || activeSearchField !== 'entity304') {
<i class="fa fa-search"></i>
}
              </span>
            </div>
            @if (entity304Options.length > 0 && activeSearchField === 'entity304') {
<div class="autocomplete-dropdown">
              @for (entity of entity304Options; track $index) {
<div class="autocomplete-item"
               
                (click)="selectEntity304(entity)">
                {{ entity.DISPLAY_VALUE || entity.LE_NAME || entity.LEID }}
              </div>
}
            </div>
}
          </div>
        </div>
      </div>
}
    </div>
  </div>
}
</div>

<div class="modal-footer dividends-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="crudLoading || isSaveClicked" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save Dividends
  </button>
  <button class="reset-button" type="button" [disabled]="crudLoading" (click)="reset()">Reset Form</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>

<!-- Confirmation Dialog using shared confirmation modal -->
<!-- Note: showConfirmDialog controls the entire modal visibility (overlay + modal) -->
<!-- The [visible] property controls the modal header visibility, set to true when modal is shown -->
@if (showConfirmDialog) {
<div class="modal-overlay confirmation-overlay">
  <div class="modal-dialog confirmation-dialog" (click)="$event.stopPropagation()">
    <gtw-confirmation-modal
      [config]="confirmModalConfig"
      [visible]="false"
      (confirmed)="onConfirmDeleteDividend()"
      (cancelled)="onCancelDeleteDividend()"
      (closed)="onCancelDeleteDividend()">
    </gtw-confirmation-modal>
  </div>
</div>
}
